import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Main-Layout-Bt" }
const _hoisted_2 = { class: "App-Main-Layout-Bt-M" }
const _hoisted_3 = { class: "App-Main-Layout-Bt-M App-Main-Layout-Bt-Conts" }
const _hoisted_4 = { class: "hidden-lg-and-up App-Main-Layout-Bt-M App-Main-Layout-Bottom-Nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, {
        justify: "center",
        gutter: 10,
        type: "flex",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            class: "hidden-md-and-down",
            xs: 24,
            sm: 20,
            md: 20,
            lg: 6,
            xl: 6
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_affix, {
                style: {"min-width":"300px"},
                target: "body",
                position: "top",
                offset: 4
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "left")
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 20,
            md: 20,
            lg: 11,
            xl: 11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_affix, {
                style: {"min-width":"300px"},
                target: "body",
                position: "top",
                offset: 0
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "top")
                  ])
                ]),
                _: 3
              }),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "middle")
              ]),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "bottom-nav")
              ])
            ]),
            _: 3
          }),
          _createVNode(_component_el_col, {
            class: "hidden-md-and-down",
            xs: 24,
            sm: 20,
            md: 20,
            lg: 7,
            xl: 7
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_affix, {
                style: {"min-width":"300px"},
                target: "body",
                position: "top",
                offset: 4
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "right")
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ])
  ]))
}